import { HTTP_TYPES } from '@src/helpers/ApiHelper';
import { request } from './verb';

interface ContactDetails {
	phone: string;
	name: string;
	email?: string;
	description?: string;
	image?: string;
	customFields?: [
		{
			key: string;
			value: string;
		}
	];
}

interface Fields {
	key: string;
	type?: string;
}

interface CustomFields {
	customFields: string[];
}

interface HiddenContacts {
	contacts: string[];
	hidden: boolean;
}

export const getContactDetailsGetChat = async (phoneNum: string) => {
	return request(HTTP_TYPES.GET, `contact/${phoneNum}/v1`)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const updateContactDetailsGetChat = async (data: ContactDetails) => {
	return request(HTTP_TYPES.POST, 'contact', data)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

//Custom Fields
export const getAllCustomFields = async () => {
	return request(HTTP_TYPES.GET, 'custom-fields')
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const createCustomField = async (data: Fields) => {
	return request(HTTP_TYPES.POST, 'custom-fields', data)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const updateCustomField = async (data: Fields, id: string) => {
	return request(HTTP_TYPES.PATCH, `custom-fields/${id}`, data)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

//Organization API

export const getOrganizationGetChat = async () => {
	return request(HTTP_TYPES.GET, 'organization')
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const deleteCustomField = async (id: string) => {
	return request(HTTP_TYPES.DELETE, `custom-fields/${id}`)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const addContactGetChat = async (data: ContactDetails) => {
	return request(HTTP_TYPES.POST, 'chats/new', data)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const getHiddenContacts = async () => {
	return request(HTTP_TYPES.GET, 'contact/hidden')
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};

export const updateHiddenContacts = async (data: HiddenContacts) => {
	return request(HTTP_TYPES.POST, 'contact/hidden', data)
		.then((res) => {
			return res?.data?.data;
		})
		.catch((err) => {
			throw new Error(err);
		});
};
